import React, { useCallback } from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import '../../../../components/sharedStyle.scss';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import SelectorWithArrow from '../../../../../../../common/components/SelectorWithArrow/SelectorWithArrow';
import { MMCategory } from '@mm/state/model/ConnectedPageModel';
import { StoreState } from '@mm/state/store-interfaces';
import connectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';

type Props = {
  facebookPageId: number;
  category: MMCategory;
};

const categories: { id: MMCategory; name: string }[] = [
  { id: 'travel_transportation', name: 'Travel & Transportation' },
  { id: 'topic_sports_recreation', name: 'Sports & Recreation' },
  { id: 'topic_shopping_retail', name: 'Shopping & Retail' },
  { id: 'topic_real_estate', name: 'Real Estate' },
  { id: 'topic_automotive', name: 'Automotive, Aircraft & Boat' },
  { id: 'topic_arts_entertainment', name: 'Arts & Entertainment' },
  { id: 'spa_beauty_personal_care', name: 'Beauty, Cosmetic & Personal Care' },
  { id: 'science_engineering', name: 'Science, Technology & Engineering' },
  { id: 'public_services_government', name: 'Public & Government Service' },
  { id: 'non_profit', name: 'Nonprofit Organization' },
  { id: 'ngo', name: 'Non-Governmental Organization (NGO)' },
  { id: 'medical_health', name: 'Medical & Health' },
  { id: 'media_news_company', name: 'Media/News Company' },
  { id: 'local_services', name: 'Local Service' },
  { id: 'legal', name: 'Legal' },
  { id: 'hotel_lodging', name: 'Hotel & Lodging' },
  { id: 'food_beverage', name: 'Food & Beverage' },
  { id: 'finance', name: 'Finance' },
  { id: 'education_company', name: 'Education' },
  { id: 'commercial_industrial', name: 'Commercial & Industrial' },
  { id: 'agriculture', name: 'Agriculture' },
  { id: 'advertising_marketing', name: 'Advertising/Marketing' },
  { id: 'community_organization', name: 'Community Organization' },
  { id: 'media', name: 'Media' },
  { id: 'interest', name: 'Interest' },
  { id: 'non_business_places', name: 'Non-Buisness Places' },
  { id: 'public_figure', name: 'Public Figure' },
  { id: 'other', name: 'Other' },
];

export const CategoryOverride = ({ facebookPageId, category }: Props) => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const onChange = useCallback(
    async (selectedCategory: MMCategory) => {
      await dispatch(
        connectedPageCRUDActions.update({
          id: facebookPageId,
          categoryOverride: selectedCategory,
        }),
      );
    },
    [facebookPageId],
  );

  return (
    <SettingSection title="Business Category:">
      <SelectorWithArrow
        selectedItem={categories.find(item => item.id === category)}
        onChange={onChange}
        items={categories}
      />
    </SettingSection>
  );
};
